module.exports = __webpack_public_path__ + "img/layout10_preview.769661fb.jpg";